import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=64cddc86&scoped=true"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"
import style0 from "./ClientView.vue?vue&type=style&index=0&id=64cddc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cddc86",
  null
  
)

export default component.exports